export const PRIMARY = "#de332a"
export const SECONDARY = "#E5E5E5"

const Color1 = "#330072"
const Color2 = "#EE3B45"
const Color3 = "#546080"
const Color4 = "#EFF0F6"
const Color5 = "#FCFCFC"
const Success = "#18BB0C"
//BACKGROUNDS
export const BACKGROUND = Color4
export const BACKGROUND_ACCORDION = "#F7F7FC"
export const BACKGROUND_INPUT = Color4
export const BACKGROUND_BRANDS_CONTAINER = "#F8F8F9"
export const BACKGROUND_BRANDS_ICONS = Color4
export const BACKGROUND_PUBLICATION = Color2
export const BACK_DROP_COLOR = "#272838"
export const WHITE = "#FFFFFF"
export const BLACK = "#000000"
export const BACKGROUND_RESULT_SIMULATION = Color5
export const BACKGROUND_DEMAND_CARD = Color5
export const BACKGROUND_DEMAND = Color5
export const BACKGROUND_MODAL = "#00000075"

//TEXT
export const TXT_PRIMARY = "#4E4B66"
export const TXT_SECONDARY = Color2
export const TXT_INPUT_PRIMARY = "#6E7191"
export const TXT_LINK = "#0476F0"
export const TXT_PROGRESS = Color1
export const TXT_TITLE_DEMAND = Color1
export const TXT_CAR_DEMAND = Color1
export const TXT_MODAL = Color1
export const TXT_MODAL_SUCCESS = Success
export const TXT_RECAP = Color3
export const TXT_MODAL_LOGOUT = Color3
export const TXT_SIMULATOR_LABEL = "#485563"
export const TXT_SIMULATION_RESULT = Color1
export const TXT_SIMULATOR_VALUES = "#002B2F"
export const TXT_BLACK = "#000"
export const TXT_PLACEHOLDER = "#86939e"


//INPUT
export const INPUT_BG_ERROR = "#FFF2F1"

//BTN
export const BTN_PRIMARY = Color2
export const BTN_PRIMARY_DISABLED = "#E55F50"
export const BTN_PRIMARY_UNDERLAY = "#C6361B"
export const BTN_SECONDARY = Color1
export const BTN_SELECTED_TABS = "#FFEDEE"
export const BTN_OFFER_UNSELECTED = "#F7F7FB"
export const BTN_OFFER_SELECTED = "#F2F0FF"
export const BTN_SAVE = Success
export const BTN_TERMS_CONDITIONS = "#136AC7"
export const BTN_TERMS_CONDITIONS_UNSELECTED = "#999"

//BORDER
export const BORDER = Color1
export const BORDER_UNSELECTED = "#F7F7FB"
export const BORDER_SELECTED = Color1
export const BORDER_ERROR = "#E61B00"
export const BORDER_DIVIDER_SIMULATOR = Color4

//SLIDER
export const SLIDER_THUMB = Color1
export const SLIDER_THUMB_MIN_TRACK = Color1
export const SLIDER_THUMB_MAX_TRACK = "#C4B6FF"

//SHADOW
export const SHADOW = "#E5E5E5"

//Icons
export const ICON_PRIMARY = "#001A72"

//ACTIONS
export const ALERT = "#E8142C"

//PROGRESS
export const PROGRESS_ACTIVE = Color1
export const PROGRESS_BACKGROUND = "#E4E7EC"

// Toast
export const TOAST_SUCCESS = "#38C976"
export const TOAST_DANGER = "#FE4646"
export const TOAST_WARNING = "#F88146"
export const TOAST_INFO = "#00B6C2"

//LOADING
export const LOADING = Color2

//status of demands
export const STATUS_0 = "#F88146"
export const STATUS_5 = "#0476F0"
export const STATUS_10 = "#38C976"
export const STATUS_20 = "#F88146"
export const STATUS_30 = "#0476F0"
export const STATUS_40 = "3F88146"
export const STATUS_50 = Color2
export const STATUS_60 = Color1
export const STATUS_70 = Color4
export const STATUS_80 = Color2
export const STATUS_90 = Color3
export const STATUS_100 = Color4
export const STATUS_110 = Color5

export default PRIMARY;
